import { cn } from "@/lib/utils";

interface LogoProps {
  variant?: "full" | "icon" | "footer";
  className?: string;
}

const Logo = ({ variant = "full", className }: LogoProps) => {
  const iconSize = variant === "footer" ? "h-7 w-10" : "h-8 w-12";

  const PulseIcon = () => (
    <svg
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(iconSize, "shrink-0")}
    >
      {/* Glow filter */}
      <defs>
        <filter id="pulseGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* Pulse line forming a W shape */}
      <polyline
        points="0,20 8,20 12,26 18,6 24,28 30,4 36,26 40,20 48,20"
        stroke="hsl(160, 100%, 50%)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        filter="url(#pulseGlow)"
      />
      {/* Dot at the end */}
      <circle cx="48" cy="20" r="2.5" fill="hsl(160, 100%, 50%)" />
    </svg>
  );

  if (variant === "icon") {
    return <PulseIcon />;
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <PulseIcon />
      <span className={cn(
        "font-display font-bold tracking-tight",
        variant === "footer" ? "text-base" : "text-lg"
      )}>
        Forex<span className="text-primary">Wire</span>Daily
        <span className="text-muted-foreground text-xs">.com</span>
      </span>
    </div>
  );
};

export default Logo;
